import angular from "angular"
import "./login.css"

loginController.$inject = ["loginService"]
function loginController(loginService) {
  var self = this
  self.message = ""
  self.login = function() {
    // console.log(self.username, self.password);
    loginService.login(self.username, self.password, function() {
      self.message = "usuario o contraseña incorrectos"
    })
  }

  self.clear = function() {
    self.message = ""
  }
}

angular.module("appModule").controller("loginController", loginController)
